import { render } from "./NavigationGuardConfirm.vue?vue&type=template&id=952c49d8"
import script from "./NavigationGuardConfirm.vue?vue&type=script&lang=js"
export * from "./NavigationGuardConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.10.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__